import request from '@/utils/request'

// GET /api/admin/settings/booking-policies - Get booking policies
export function getBookingPolicies() {
  return request({
    url: '/api/admin/settings/booking-policies',
    method: 'get'
  })
}

// PUT /api/admin/settings/booking-policies - Update booking policies
export function updateBookingPolicies(data) {
  return request({
    url: '/api/admin/settings/booking-policies',
    method: 'put',
    data
  })
}
